/**
 * LAC-010 — cutover Br Envio legado (SA interno).
 */
import axios from "axios";
import { ApiSuccess, saUrl } from "./api_helper";

export type SaLegacyConnection = {
  ok: boolean;
  database: string;
  host: string;
  cliente_count: number | null;
  /** false = LEGACY_FILES_ROOT vazio — UI avisa se “Arquivos” estiver marcado. */
  files_root_configured: boolean;
  message: string;
};

export type SaLegacyClient = {
  legacy_cliente_id: number;
  name: string;
  email: string;
  owner_name: string;
  active: boolean;
  legacy_plan_id: number | null;
  document: string;
  domain: string;
  contract_date: string | null;
  migration_status: string | null;
  tenant_id: number | null;
};

export type SaLegacyPreviewCounts = {
  emails_total: number;
  emails_active: number;
  tags: number;
  tag_links: number;
  campaigns: number;
  field_definitions: number;
  field_values: number;
  files_resolvable: number;
  files_missing: number;
};

export type SaLegacyPreviewClient = {
  legacy_cliente_id: number;
  name?: string;
  email?: string;
  active?: boolean;
  already_migrated?: boolean;
  tenant_id?: number | null;
  counts?: SaLegacyPreviewCounts;
  error?: string;
  status?: string;
};

export type SaLegacyPreviewResult = {
  run_id: number;
  dry_run: boolean;
  clients: SaLegacyPreviewClient[];
};

export type SaLegacyExecuteClient = {
  legacy_cliente_id: number;
  plan_id: number;
  billing_channel: "self_serve" | "brdominio";
};

export type SaLegacyRunMap = {
  id: number;
  legacy_cliente_id: number;
  tenant_id: number | null;
  status: string;
  plan_id: number | null;
  billing_channel: string | null;
  counts: Record<string, number> | null;
  error_message: string | null;
};

export type SaLegacyRun = {
  id: number;
  status: string;
  dry_run: boolean;
  options: Record<string, boolean> | null;
  report: {
    clients?: Array<{
      legacy_cliente_id: number;
      tenant_id?: number;
      status?: string;
      owner_email?: string;
      owner_temp_password?: string;
      counts?: Record<string, number>;
      error?: string;
    }>;
  } | null;
  error_message: string | null;
  started_at?: string | null;
  finished_at?: string | null;
  maps: SaLegacyRunMap[];
};

export const getSaLegacyConnection = (): Promise<
  ApiSuccess<SaLegacyConnection>
> => axios.get(saUrl("/super-admin/legacy-migration/connection"));

export const getSaLegacyClients = (params?: {
  search?: string;
}): Promise<ApiSuccess<{ items: SaLegacyClient[] }>> =>
  axios.get(saUrl("/super-admin/legacy-migration/clients"), { params });

export const previewSaLegacyMigration = (payload: {
  legacy_cliente_ids: number[];
  include_campaigns?: boolean;
  include_fields?: boolean;
  include_files?: boolean;
}): Promise<ApiSuccess<SaLegacyPreviewResult>> =>
  axios.post(saUrl("/super-admin/legacy-migration/preview"), payload);

export const executeSaLegacyMigration = (payload: {
  clients: SaLegacyExecuteClient[];
  include_campaigns?: boolean;
  include_fields?: boolean;
  include_files?: boolean;
}): Promise<ApiSuccess<{ run_id: number; status: string; clients: unknown[] }>> =>
  axios.post(saUrl("/super-admin/legacy-migration/execute"), payload);

export const getSaLegacyRun = (
  runId: number
): Promise<ApiSuccess<SaLegacyRun>> =>
  axios.get(saUrl(`/super-admin/legacy-migration/runs/${runId}`));
